import { render, staticRenderFns } from "./nutritionComponents.vue?vue&type=template&id=bbf418ac&scoped=true"
import script from "./nutritionComponents.vue?vue&type=script&lang=js"
export * from "./nutritionComponents.vue?vue&type=script&lang=js"
import style0 from "./nutritionComponents.vue?vue&type=style&index=0&id=bbf418ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf418ac",
  null
  
)

export default component.exports